import {memo, useEffect, useMemo} from "react";
import {Bar} from '@ant-design/charts';

const GrowthRateChart = memo(({data, customConfig = {}}) => {

    const growth_avg = useMemo(() => {
        return data?.map((skill) => {
            return skill.percentage;
        }).reduce((sum, a) => sum + a, 0) / data?.length;
    }, [data]);

    const growth_min = useMemo(() => {
        return Math.min(...data?.map((skill) => {
            return skill.percentage;
        }))
    }, [data]);

    const growth_rate = useMemo(() => {
        return [
            ...data?.map(function(skill) {
                return {
                    'skill': skill.skill,
                    'percentage': skill.percentage,
                    'type': 'ปัจจุบัน'
                }
            }),
            ...data?.map(function(skill) {
                return {
                    'skill': skill.skill,
                    'percentage': growth_min / 2,
                    'type': 'ข้อมูลตั้งต้น (ปีก่อน)'
                }
            })
        ]
    }, [data, growth_min]);

    var config = {
        data: growth_rate,
        xField: 'percentage',
        yField: 'skill',
        seriesField: 'type',
        isStack: true,
        dodgePadding: 4,
        intervalPadding: 20,
        color: ['#215e3c', '#2e8b57'],
        minBarWidth: 10,
        label: {
            layout: [
                { type: 'interval-adjust-position' },
                { type: 'interval-hide-overlap' },
                { type: 'adjust-color' },
            ],
            content: (_ref) => {
                return _ref?.type === 'ปัจจุบัน' ? `+${_ref.percentage}%` : '0%'
            },
                // formatter: (value) => `+${Math.max(value, 0).toFixed(2)}%`

        },
        meta: {
            percentage: {
                formatter: (value) => `+${Math.max(value, 0).toFixed(2)}%`
            }
        },
        scrollbar: {
            type: 'vertical'
        },
        // slider: {
        //     start: 0.7,
        //     end: 1
        // }
    };

    return <Bar {...config} />;
})

export default GrowthRateChart;